export default __webpack_public_path__ + "static/media/stackoverflow.0123b8df.png";